import { render, staticRenderFns } from "./NewBanner.vue?vue&type=template&id=0d155ba0&scoped=true&"
import script from "./NewBanner.vue?vue&type=script&lang=js&"
export * from "./NewBanner.vue?vue&type=script&lang=js&"
import style0 from "./NewBanner.vue?vue&type=style&index=0&lang=less&"
import style1 from "./NewBanner.vue?vue&type=style&index=1&id=0d155ba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d155ba0",
  null
  
)

export default component.exports